// extracted by mini-css-extract-plugin
export default {"order-row":"CustomerSettingsPage_order-row__zy7oB","save-btn":"CustomerSettingsPage_save-btn__it52T"};